export interface IDashDrugUseHistory {
    
}